import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import StudentDashboard from '@pages/StudentPortal/StudentDashboard/StudentDashboard';
import StudentChangePassword from '@pages/StudentPortal/StudentChangePassword/StudentChangePassword';
import StudentProfile from '@pages/StudentPortal/StudentProfile/StudentProfile';
import StudentRecordings from '@pages/StudentPortal/StudentRecordings/StudentRecordings';
import WeekFlowPage from '@pages/StudentPortal/StudentTasks/WeekFlowPage';
import StudentSkillProfilePage from '@pages/StudentPortal/StudentSkillProfile/StudentSkillProfilePage';
import StudentNotebook from '@pages/StudentPortal/StudentNotebook/StudentNotebook';

// JOURNEY pages are code-split — a CLASSIC (Cohort 1) student never downloads
// this chunk. `JourneyShell` provides the <Suspense> boundary.
const JourneyHome = lazy(() => import('@pages/StudentPortal/Journey/JourneyHome'));
const WeekHub = lazy(() => import('@pages/StudentPortal/Journey/WeekHub'));
const JourneyReading = lazy(() => import('@pages/StudentPortal/Journey/JourneyReading'));
const CodingFlow = lazy(() => import('@pages/StudentPortal/Journey/CodingFlow'));
const JourneyCalendar = lazy(() => import('@pages/StudentPortal/Journey/JourneyCalendar'));
const JourneyAchievements = lazy(() => import('@pages/StudentPortal/Journey/JourneyAchievements'));
const JourneyLab = lazy(() => import('@pages/StudentPortal/Journey/JourneyLab'));

export const studentLayoutRoutes: RouteObject[] = [
    // ── CLASSIC (Cohort 1) — rendered by StudentLayoutInner ─────────────────
    {
        path: '/student/dashboard',
        element: <StudentDashboard />,
    },
    {
        path: '/student/skill-profile',
        element: <StudentSkillProfilePage />,
    },
    {
        path: '/student/profile',
        element: <StudentProfile />,
    },
    {
        path: '/student/recordings',
        element: <StudentRecordings />,
    },
    {
        path: '/student/tasks',
        element: <Navigate to="/student/weeks/1" replace />,
    },
    {
        path: '/student/weeks/:weekNumber',
        element: <WeekFlowPage />,
    },
    {
        path: '/student/notebook',
        element: <StudentNotebook />,
    },

    // ── JOURNEY (Cohort 2+) — rendered by JourneyShell (code-split) ────────
    { path: '/student/journey', element: <JourneyHome /> },
    { path: '/student/journey/week/:weekNumber', element: <WeekHub /> },
    { path: '/student/learn/:weekNumber', element: <JourneyReading /> },
    { path: '/student/code/:weekNumber', element: <CodingFlow /> },
    { path: '/student/lab', element: <JourneyLab /> },
    { path: '/student/calendar', element: <JourneyCalendar /> },
    { path: '/student/achievements', element: <JourneyAchievements /> },
];

export const studentStandaloneRoutes: RouteObject[] = [
    {
        path: '/student/change-password',
        element: <StudentChangePassword />,
    },
];
